export default __webpack_public_path__ + "static/media/deyvi-conde.d2c6e588.png";